import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  OilBlockStoreActions,
  OilBlockStoreSelectors,
  OilBlockStoreReducer,
} from './index';
import { OilBlockDto } from '@cradua/data';

@Injectable()
export class OilBlockFacade {
  constructor(
    private store: Store<OilBlockStoreReducer.OilBlockPartialState>
  ) {}

  oilBlockRecord$ = this.store.select(OilBlockStoreSelectors.getSelected);
  oilBlockRecordError$ = this.store.select(
    OilBlockStoreSelectors.getOilBlockError
  );

  getselected() {
    return this.store.select(OilBlockStoreSelectors.getSelected);
  }

  get isLoadingOilBlock() {
    this.store.dispatch(OilBlockStoreActions.loadOilBlock());
    return this.store.select(OilBlockStoreSelectors.loadingOilBlock);
  }

  get loadOilBlock() {
    this.store.dispatch(OilBlockStoreActions.loadOilBlock());
    return this.store.select(OilBlockStoreSelectors.getAllOilBlock);
  }

  addOilBlock(newOilBlock: OilBlockDto[]) {
    this.store.dispatch(OilBlockStoreActions.addOilBlock({ newOilBlock }));
  }

  updateOilBlock(updateOilBlock: OilBlockDto[]) {
    this.store.dispatch(
      OilBlockStoreActions.updateOilBlock({ updateOilBlock })
    );
  }

  removeOilBlock(ids: string[]) {
    this.store.dispatch(OilBlockStoreActions.removeOilBlock({ ids }));
  }
}
